import React, { createContext, ReactNode, useState } from "react";

export interface IMedia {
  url: string;
  type: IMediaType;
  alt: string | null | undefined;
}

export enum IMediaType {
  Image = "IMAGE",
  Youtube = "YOUTUBE",
  Vimeo = "VIMEO",
}

interface IGalleryContext {
  medias: IMedia[];
  selectedMediaIndex: number;
  onChange: (mediaIndex: number) => void;
}

export const GalleryContext = createContext<IGalleryContext>({
  medias: [],
  selectedMediaIndex: 0,
  onChange: () => {},
});

interface IGalleryStateProps {
  medias: IMedia[];
  children: ReactNode;
}

export const GalleryStateConsumer = GalleryContext.Consumer;

export function GalleryState({ medias, children }: IGalleryStateProps) {
  const [selectedMediaIndex, setSelectedMedia] = useState<number>(0);

  return (
    <GalleryContext.Provider
      value={{
        selectedMediaIndex,
        medias,
        onChange: (mediaIndex) => {
          setSelectedMedia(Math.max(Math.min(mediaIndex, medias.length - 1), 0));
        },
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
}
